<section>
  <div class="card-header">
    <span class="h6">Manage Brand</span>
    <button class="dialog-close-btn" mat-dialog-close>
      <i class="fa fa-times fa-lg" aria-hidden="true"></i>
    </button>
  </div>
  <div class="form-container" *ngIf="showForm">
    <form [formGroup]="brandForm">
      <div class="">
        <div class="row mb-2">
          <div class="col-md-4">Brand Name</div>
          <div class="col-md-8">
            <input
              [ngClass]="{
                'invalid-input':
                  brandFormControl.invalid &&
                  (brandFormControl.dirty || brandFormControl.touched)
              }"
              class="form-control form-control-sm"
              type="text"
              [formControl]="brandFormControl"
            />
            <div
              *ngIf="
                brandFormControl.invalid &&
                (brandFormControl.dirty || brandFormControl.touched)
              "
              class="text-danger"
            >
              <div><small>Brand name is required.</small></div>
            </div>
          </div>
        </div>
        <div class="row mb-2">
          <div class="col-md-4">Parent Brand</div>
          <div class="col-md-8">
            <app-tree-dropdown
              class="brand-dropdown"
              [isManageable]="false"
              [dataSource]="brandData"
              [dataService]="brandProvider()"
              (whenItemSelected)="brandSelected($event)"
              [selectFormControl]="parentFormControl"
              [placeHolder]="'Search a parent brand'"
              ngDefaultControl
            >
            </app-tree-dropdown>
          </div>
        </div>
      </div>

      <div class="save-btn">
        <button
          mat-button
          class="mat-inherit-line-height btn-green"
          (click)="saveBrandData()"
        >
          Save
        </button>
        <button
          mat-button
          class="mat-inherit-line-height"
          (click)="showForm = false"
        >
          Cancel
        </button>
      </div>
    </form>
  </div>

  <div class="categories-title">
    <h4>
      Brands
      <span class="add-new-label"
        ><button
          *ngIf="brandData.length > 0"
          (click)="addNewBrand()"
          appPermission
          [permissions]="userPermissions"
          [type]="'create'"
        >
          <i class="fa fa-plus-circle"></i>Add New Brand
        </button></span
      >
    </h4>
  </div>
  <div class="empty-list text-center mt-4" *ngIf="isLoaded">
    <p class="text-muted" *ngIf="brandData.length == 0">No Brand available</p>
    <button
      mat-button
      class="add-new-btn"
      *ngIf="brandData.length == 0 && !showForm"
      appPermission
      [permissions]="userPermissions"
      [type]="'create'"
      (click)="addNewBrand()"
    >
      Add New Brand
    </button>
  </div>
  <div class="brand-holder scrolly">
    <app-tree-container
      (applyData)="applyBrand($event)"
      (editData)="editBrand($event)"
      (deleteData)="deleteBrand($event)"
      [treeData]="brandData"
    >
    </app-tree-container>
  </div>

  <div class="cancel-btn">
    <button
      mat-button
      class="mat-inherit-line-height height-40"
      mat-dialog-close
    >
      Cancel
    </button>
  </div>
</section>
